export default __webpack_public_path__ + "static/media/971.4cddce37.png";